// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1UGn1","requiredAsterisk":"Info_requiredAsterisk__1NzPy"};